var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.close,
          expression: "close",
        },
      ],
      staticClass: "post-filter",
    },
    [
      !_vm.hideSearchBar
        ? _c("div", { staticClass: "filter-section-search" }, [
            _c("div", { staticClass: "input" }, [
              _c("div", { staticClass: "container-svg" }, [
                _c(
                  "svg",
                  {
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "auto",
                      height: "auto",
                      viewBox: "0 0 21 21",
                      fill: "none",
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        d: "M17.0625 8.53125C17.0625 10.4139 16.4514 12.1529 15.4219 13.5639L20.6145 18.7605C21.1271 19.2732 21.1271 20.1059 20.6145 20.6186C20.1018 21.1312 19.2691 21.1312 18.7564 20.6186L13.5639 15.4219C12.1529 16.4555 10.4139 17.0625 8.53125 17.0625C3.81855 17.0625 0 13.2439 0 8.53125C0 3.81855 3.81855 0 8.53125 0C13.2439 0 17.0625 3.81855 17.0625 8.53125ZM8.53125 14.4375C9.30687 14.4375 10.0749 14.2847 10.7915 13.9879C11.5081 13.6911 12.1592 13.256 12.7076 12.7076C13.256 12.1592 13.6911 11.5081 13.9879 10.7915C14.2847 10.0749 14.4375 9.30687 14.4375 8.53125C14.4375 7.75563 14.2847 6.9876 13.9879 6.27103C13.6911 5.55445 13.256 4.90335 12.7076 4.3549C12.1592 3.80645 11.5081 3.3714 10.7915 3.07459C10.0749 2.77777 9.30687 2.625 8.53125 2.625C7.75563 2.625 6.98761 2.77777 6.27103 3.07459C5.55445 3.3714 4.90335 3.80645 4.3549 4.3549C3.80645 4.90335 3.3714 5.55445 3.07459 6.27103C2.77777 6.9876 2.625 7.75563 2.625 8.53125C2.625 9.30687 2.77777 10.0749 3.07459 10.7915C3.3714 11.5081 3.80645 12.1592 4.3549 12.7076C4.90335 13.256 5.55445 13.6911 6.27103 13.9879C6.98761 14.2847 7.75563 14.4375 8.53125 14.4375Z",
                        fill: "#E3D2EE",
                      },
                    }),
                  ]
                ),
              ]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.lazy",
                    value: _vm.models.search,
                    expression: "models.search",
                    modifiers: { lazy: true },
                  },
                ],
                attrs: { placeholder: _vm.$t("dash.posts.list.search") },
                domProps: { value: _vm.models.search },
                on: {
                  change: function ($event) {
                    return _vm.$set(_vm.models, "search", $event.target.value)
                  },
                },
              }),
            ]),
          ])
        : _vm._e(),
      _c("div", { staticClass: "filter-section-status" }, [
        _c("div", { staticClass: "container-title" }, [
          _c("p", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("dash.posts.filter.status")) + " "),
            _c("span", [_vm._v("(" + _vm._s(_vm.countStatusShow) + ")")]),
          ]),
          _vm.countStatusShow < 9
            ? _c(
                "p",
                { staticClass: "reset", on: { click: _vm.addAllStatus } },
                [_vm._v(_vm._s(_vm.$t("dash.posts.filter.show-all")))]
              )
            : _c(
                "p",
                { staticClass: "reset", on: { click: _vm.removeAllStatus } },
                [_vm._v(_vm._s(_vm.$t("dash.posts.filter.hide-all")))]
              ),
        ]),
        _c(
          "div",
          { staticClass: "list" },
          [
            _vm._l(
              [
                "scheduled",
                "posted",
                "draft",
                "pending",
                "failed",
                "removed",
                "standby",
                "awaiting_approval",
                "to_validate",
              ],
              function (name) {
                return [
                  _c(
                    "div",
                    {
                      staticClass: "badge-status",
                      class: { disable: !_vm.filter.statusDisplay[name] },
                      attrs: { status: name },
                      on: {
                        click: function ($event) {
                          return _vm.toggleStatus(name)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t(`dash.post.${name}`)) +
                          "\n                "
                      ),
                    ]
                  ),
                ]
              }
            ),
          ],
          2
        ),
      ]),
      _c("div", { staticClass: "filter-section-type" }, [
        _c("div", { staticClass: "container-title" }, [
          _c("p", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("dash.posts.filter.type")) + " "),
            _c("span", [_vm._v("(" + _vm._s(_vm.countTypesShow) + ")")]),
          ]),
          _vm.countTypesShow < 6
            ? _c(
                "p",
                { staticClass: "reset", on: { click: _vm.addAllTypes } },
                [_vm._v(_vm._s(_vm.$t("dash.posts.filter.show-all")))]
              )
            : _c(
                "p",
                { staticClass: "reset", on: { click: _vm.removeAllTypes } },
                [_vm._v(_vm._s(_vm.$t("dash.posts.filter.hide-all")))]
              ),
        ]),
        _c(
          "div",
          { staticClass: "list" },
          [
            _vm._l(
              ["image", "video", "reel", "story", "carousel", "document"],
              function (type) {
                return [
                  _c(
                    "div",
                    { key: type, staticClass: "type" },
                    [
                      _c("Checkbox", {
                        attrs: {
                          id: type,
                          prefixId: "filterPost",
                          isChecked: _vm.filter.typesDisplay[type],
                          remove: _vm.toggleType,
                          add: _vm.toggleType,
                        },
                      }),
                      _c("label", { attrs: { for: `filterPost${type}` } }, [
                        _vm._v(_vm._s(type)),
                      ]),
                    ],
                    1
                  ),
                ]
              }
            ),
          ],
          2
        ),
      ]),
      _vm.showDateRange
        ? _c("div", { staticClass: "filter-section-date" }, [
            _c("div", { staticClass: "container-title" }, [
              _c("p", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.$t("dash.posts.filter.date"))),
              ]),
              _vm.dateRange.startDate || _vm.dateRange.endDate
                ? _c(
                    "p",
                    { staticClass: "reset", on: { click: _vm.clearDates } },
                    [_vm._v(_vm._s(_vm.$t("dash.posts.filter.show-all")))]
                  )
                : _vm._e(),
            ]),
            _c("div", { staticClass: "container-dates" }, [
              _c("div", { staticClass: "dates" }, [
                _c("input", {
                  attrs: { type: "date" },
                  domProps: { value: _vm.dateRange.startDate },
                  on: {
                    input: function ($event) {
                      return _vm.setStartDate($event.target.value)
                    },
                  },
                }),
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("dash.posts.filter.date-to")) +
                    "\n                "
                ),
                _c("input", {
                  attrs: { type: "date" },
                  domProps: { value: _vm.dateRange.endDate },
                  on: {
                    input: function ($event) {
                      return _vm.setEndDate($event.target.value)
                    },
                  },
                }),
              ]),
            ]),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }